















































































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import AgroGenericModal from "@/components/agroGenericModal/AgroGenericModal.vue";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import i18n from "@/i18n";
import AgroResponsiveTable from "@/components/agroResponsiveTable/AgroResponsiveTable.vue";
import { AnalysesListRow, AnalysesFilter } from "@/api/analyses/types";
import * as analysesApi from "@/api/analyses";
import Loading from "@/components/loading/Loading.vue";
import AnalysesBadge from "../analyses/AnalysesBadge.vue";
import AnalysisStatusIcons from "@/utils/iconAnalysisStatus";
import { AnalysisStatus as Status } from "@/api/analyses_status/types";
import AgroTablePagination from "@/components/agroTablePagination/AgroTablePagination.vue";
import { Page } from "@/api/types";

const getAnalysesRoute = (route: string) => (uuid: string) => {
  return {
    name: route,
    params: { uuid, source: "farms-home" },
  };
};

@Component({
  name: "ModalAnalysesStatus",
  components: {
    AgroGenericModal,
    icon: AgroIcons,
    AgroResponsiveTable,
    Loading,
    AnalysesBadge,
    AgroTablePagination,
  },
})
export default class ModalAnalysesStatus extends Vue {
  @Prop({ type: Boolean, default: false })
  private modalVisible!: boolean;

  private rows: AnalysesListRow[] = [];

  private tableColumns = [
    { name: "farmName", sortable: false },
    { name: "ownerName", sortable: false },
    { name: "cropType", sortable: false },
    { name: "analysisType", sortable: false },
    { name: "stepMessage", sortable: false },
  ];

  private prefix: string = "farms-home.table-analyses-status";

  private columnsLabel: object = {};

  private isLoading = true;
  private searchTimer: any;
  private currentPage = 0;
  private page = new Page(0, 12);

  private farmName: string | null = null;
  private ownerName: string | null = null;
  private cropType: string | null = null;
  private status: string | null = null;

  private pageSize: number | null = 10;
  private totalPages: number | null = null;
  private totalElements: number | null = null;



  private async paginate() {
    const analysesFilter: AnalysesFilter = {
      farmName: this.farmName!,
      ownerName: this.ownerName!,
      stepStatus: this.status? this.status : undefined,
      cropType: this.cropType? this.cropType : undefined,
    }
    this.isLoading = true;
    try {
      const response = await analysesApi.getAllAnalysesStatusByFilter(analysesFilter, this.page);
      this.rows = response.data;
      this.pageSize = response.size;
      this.totalPages = response.totalPages;
      this.totalElements = response.totalElements;
      this.isLoading = false;
    } catch (e) {
    } finally {
      this.isLoading = false;
    }
  }

  private cropTypeIconName(status: string, step: string) {
    return AnalysisStatusIcons.fromText(status, step);
  }

  private getTitle(status: AnalysesListRow) {
    if (status.finishedWithSuccess) {
      return this.$t("analysis.finished-with-success");
    }
    return `${
      this.$t("analysis.step." + status.step) +
      " - " +
      this.$t("analysis.status." + status.stepStatus)
    }`;
  }


  private paginateTimeOut(page: Page, immediate: boolean = false) {
    this.page = page;

    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
    }
    this.searchTimer = setTimeout(
      () => {
        this.paginate();
      },
      immediate ? 0 : 800
    );
  }

  private async created() {
   await this.paginate();
    window.addEventListener("keydown", this.escObserver);
    this.columnsLabel = {
      farmName: i18n.t("farms-home.table-analyses-status.farmName"),
      ownerName: i18n.t("farms-home.table-analyses-status.ownerName"),
      cropType: i18n.t("farms-home.table-analyses-status.cropType"),
      analysisType: i18n.t("farms-home.table-analyses-status.analysisType"),
      stepMessage: i18n.t("farms-home.table-analyses-status.stepMessage"),
    };
  }

  private  async mounted() {
    await new Promise(resolve => setInterval(() => resolve(this.paginate()), 60000));
  };

  private escObserver(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.closeModalStatus();
    }
  }

  private changeFilterCropType(event: any) {
    this.cropType = event.target.value;
    this.paginateTimeOut(this.page, true);
  }

  private changeFilterStatus(event: any) {
    this.status = event.target.value;
    this.paginateTimeOut(this.page, true);
  }

  @Emit("closeModalStatus")
  private closeModalStatus() {}
}
